/* global document */

export const OBSCURED_CLASS = 'media-protection-obscured';
export const PROTECTED_SRC_ATTR = 'data-roverpix-protected-src';

export const isPrintScreenKey = (event) => {
	const { code, key, keyCode } = event;

	if (code === 'PrintScreen' || key === 'PrintScreen') return true;
	if (code === 'Print' || key === 'Print') return true;
	if (keyCode === 44) return true;

	return false;
};

export const isMacScreenshotShortcut = (event) => {
	if (!event.metaKey || !event.shiftKey) return false;
	return ['3', '4', '5'].includes(event.key);
};

export const isLinuxScreenshotShortcut = (event) => {
	if (!isPrintScreenKey(event)) return false;
	return event.shiftKey || event.altKey || event.ctrlKey;
};

export const shouldObscureOnKeyDown = (event) => {
	if (isPrintScreenKey(event)) return true;
	if (isMacScreenshotShortcut(event)) return true;
	return false;
};

export const shouldBlockShortcut = (event) => {
	const { ctrlKey, metaKey, key, code } = event;
	const mod = ctrlKey || metaKey;

	if (key === 'F12' || code === 'F12') return true;
	if (mod && (key === 's' || key === 'S')) return true;
	if (mod && (key === 'p' || key === 'P')) return true;
	if (mod && event.shiftKey && (key === 'I' || key === 'i')) return true;
	if (mod && event.shiftKey && (key === 'J' || key === 'j')) return true;

	return shouldObscureOnKeyDown(event);
};

export const stripProtectedMediaSources = () => {
	if (typeof document === 'undefined') return;

	document.querySelectorAll('.ProtectedMedia img, .ProtectedMedia video').forEach((element) => {
		const source = element.currentSrc || element.src;

		if (!source || element.hasAttribute(PROTECTED_SRC_ATTR)) return;

		element.setAttribute(PROTECTED_SRC_ATTR, source);
		element.removeAttribute('src');

		if (element.tagName === 'VIDEO') {
			element.load();
		}
	});
};

export const restoreProtectedMediaSources = () => {
	if (typeof document === 'undefined') return;

	document.querySelectorAll(`[${PROTECTED_SRC_ATTR}]`).forEach((element) => {
		const source = element.getAttribute(PROTECTED_SRC_ATTR);

		if (source) {
			element.src = source;
		}

		element.removeAttribute(PROTECTED_SRC_ATTR);
	});
};

export const obscure = () => {
	if (typeof document === 'undefined' || !document.body) return;

	stripProtectedMediaSources();
	document.body.classList.add(OBSCURED_CLASS);
};

export const restore = () => {
	if (typeof document === 'undefined' || !document.body) return;

	document.body.classList.remove(OBSCURED_CLASS);
	restoreProtectedMediaSources();
};

export const isObscured = () => {
	if (typeof document === 'undefined' || !document.body) return false;
	return document.body.classList.contains(OBSCURED_CLASS);
};

export default {
	OBSCURED_CLASS,
	PROTECTED_SRC_ATTR,
	isPrintScreenKey,
	isMacScreenshotShortcut,
	isLinuxScreenshotShortcut,
	shouldObscureOnKeyDown,
	shouldBlockShortcut,
	stripProtectedMediaSources,
	restoreProtectedMediaSources,
	obscure,
	restore,
	isObscured,
};
